<div fxLayout="row" fxLayoutAlign="center center" class="layout-wrapper"> 
    <div class="flex-wrapper" fxFlexFill> 
        <ng-content></ng-content> 
    </div> 
</div>